module.exports = __webpack_public_path__ + "img/dlLogo.613ecc69.png";